import { z } from 'zod'

export const GetProductTemplateCategoriesSchema = z.object({
    handle: z.string().min(1),
})
